import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../../utils/index.js';
import styles from './styles.css.js';

function TableData(props) {
  const {
    className,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement("td", _extends({
    className: _cs(className, styles.td)
  }, otherProps), children);
}

var TableData$1 = genericMemo(TableData);

export { TableData$1 as default };
//# sourceMappingURL=index.js.map
